export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: "1",
    slug: "yule-bagua",
    name: "娱乐八卦",
    description: "明星动态、综艺爆料、影视圈秘闻一网打尽",
    icon: "ri-movie-line",
    articleCount: 128,
    imageUrl:
      "https://readdy.ai/api/search-image?query=Neon%20lit%20city%20nightlife%20street%20scene%20with%20bokeh%20lights%2C%20celebrity%20paparazzi%20atmosphere%2C%20warm%20red%20and%20orange%20tones%2C%20cinematic%20style%2C%20editorial%20photography&width=400&height=500&seq=cg-cat-01&orientation=portrait",
  },
  {
    id: "2",
    slug: "shehui-redian",
    name: "社会热点",
    description: "全网热议的社会事件与民生话题深度追踪",
    icon: "ri-global-line",
    articleCount: 95,
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20digital%20news%20headlines%20floating%20in%20warm%20orange%20and%20amber%20gradient%20space%2C%20modern%20minimalist%20design%2C%20soft%20glowing%20light%20particles%2C%20editorial%20illustration&width=400&height=500&seq=cg-cat-02&orientation=portrait",
  },
  {
    id: "3",
    slug: "mingxing-heiliao",
    name: "明星黑料",
    description: "深度扒皮、翻车实录、不为人知的内幕曝光",
    icon: "ri-fire-line",
    articleCount: 76,
    imageUrl:
      "https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20stage%20with%20red%20and%20warm%20amber%20lighting%2C%20mysterious%20silhouette%20figure%2C%20theater%20curtains%20partially%20open%2C%20cinematic%20atmosphere%2C%20high%20contrast%2C%20editorial%20style&width=400&height=500&seq=cg-cat-03&orientation=portrait",
  },
  {
    id: "4",
    slug: "wangluo-baoliao",
    name: "网络爆料",
    description: "匿名爆料、论坛热帖、社交媒体突发消息汇总",
    icon: "ri-chat-3-line",
    articleCount: 203,
    imageUrl:
      "https://readdy.ai/api/search-image?query=Digital%20chat%20bubbles%20and%20message%20threads%20floating%20in%20abstract%20space%2C%20warm%20coral%20and%20peach%20gradient%20background%2C%20soft%20glow%20effects%2C%20modern%20minimalist%20illustration&width=400&height=500&seq=cg-cat-04&orientation=portrait",
  },
  {
    id: "5",
    slug: "jinri-dagua",
    name: "今日大瓜",
    description: "当天最热、最劲爆的瓜集中呈现",
    icon: "ri-flashlight-line",
    articleCount: 45,
    imageUrl:
      "https://readdy.ai/api/search-image?query=Explosive%20burst%20of%20warm%20orange%20and%20red%20energy%20particles%2C%20dynamic%20motion%20blur%2C%20abstract%20art%2C%20high%20impact%20visual%2C%20centered%20composition%2C%20editorial%20photography%20style&width=400&height=500&seq=cg-cat-05&orientation=portrait",
  },
  {
    id: "6",
    slug: "meiri-dasai",
    name: "每日大赛",
    description: "每日网友投票评选的最热门话题与事件PK",
    icon: "ri-trophy-line",
    articleCount: 62,
    imageUrl:
      "https://readdy.ai/api/search-image?query=Golden%20trophy%20on%20minimalist%20pedestal%20with%20warm%20spotlight%2C%20elegant%20awards%20ceremony%20atmosphere%2C%20soft%20golden%20and%20amber%20tones%2C%20luxury%20editorial%20photography&width=400&height=500&seq=cg-cat-06&orientation=portrait",
  },
];